/* unplugin-vue-components disabled */import { render } from "./BikeLaneInfoCard.vue?vue&type=template&id=0c54deb4&ts=true"
import script from "./BikeLaneInfoCard.vue?vue&type=script&lang=ts"
export * from "./BikeLaneInfoCard.vue?vue&type=script&lang=ts"

import "./BikeLaneInfoCard.vue?vue&type=style&index=0&id=0c54deb4&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__